<template lang="pug">
.section-seja-visto
  .content
    h1.titulo-principal
      | Seja Visto,
      br
      span.destaque Seja Nexa
        .linha-verde
    h2.subtitulo
      span.nexa-skills Nexa Skills:
      |  Destaque-se em um mundo competitivo.
    p.descricao
      | Uma plataforma feita para destacar competências técnicas.
    .cta
      ButtonPadrao.btn-cta(@click="irParaCadastro")
        | Venha ser Nexa!
</template>

<script>
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue'

export default {
  name: 'SejaVisto',
  components: {
    ButtonPadrao
  },
  methods: {
    irParaCadastro() {
      this.$router.push('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.section-seja-visto {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 48px 24px;
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  font-family: 'ubuntu', sans-serif;

  .content {
    max-width: 1024px;
    width: 100%;

    .titulo-principal {
      font-size: 96px;
      font-weight: 700;
      line-height: 1;
      color: rgb(245, 245, 245);
      margin-bottom: 24px;
      margin-top: 0;
      text-shadow: rgba(109, 215, 8, 0.5) 0px 0px 10px;

      .destaque {
        color: #6dd708;
        position: relative;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        
        .linha-verde {
          position: relative;
          bottom: 0;
          left: 0;
          animation: piscar 2s ease-in-out infinite;
          width: 5%;
          height: 8px;
          background: #6dd708;
          box-shadow: rgba(109, 215, 8, 0.5) 0px 0px 10px;
        }
      }

    }

    .subtitulo {
      font-size: 36px;
      font-weight: 600;
      color: #f5f5f5;
      margin: 10px 0 25px 0;
      line-height: 1.3;

      .nexa-skills {
        color: #6dd708;
        font-weight: 600;
        font-family: jetbrains-mono, monospace;
      }
    }

    .descricao {
      font-size: 24px;
      color: #969992;
      margin-bottom: 48px;
      line-height: 1.5;
    }

    .cta {
      width: 100%;
      display: flex;
      justify-content: center;

      .btn-cta {
        background: #6dd708;
        color: #191919;
        font-size: 18px;
        font-weight: 600;
        padding: 16px 32px;
        border: none;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
        box-shadow: rgba(109, 215, 8, 0.5) 0px 0px 10px;
        font-family: "Inter", sans-serif;


        &:hover {
          background: #5cb806;
          transform: scale(1.05);
        }
      }
    }
  }

  @media (max-width: 768px) {
    .content {
      .titulo-principal {
        font-size: 48px;

        .destaque{
          .linha-verde{
            height: 5px;
            left: 5px;
          }
        }
      }

      .subtitulo {
        font-size: 24px;
      }

      .descricao {
        font-size: 16px;
      }
    }
  }

  @media (max-width: 480px) {
    .content {
      .titulo-principal {
        font-size: 36px;
      }

      .subtitulo {
        font-size: 20px;
      }
    }
  }
}

@keyframes piscar {
  0%, 100% {
    opacity: 1;
    text-shadow: 0 0 5px rgba(109, 215, 8, .8);
  }
  50% {
    opacity: .6;
    text-shadow: 0 0 10px rgba(109, 215, 8, .4);
  }
}
</style>
